import client from "../client";
import { GetTransactionRPSRoomRepsonse } from "./get_transaction_rps_room";

export default function API(): Promise<GetTransactionRPSRoomRepsonse[]> {
  return client
    .get(`gameinhouse/rps/get_transaction_rps_my_room`)
    .then((response) => response.data);
}
